
// library import
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Icon from "@mdi/react";
import { mdiContentCopy } from "@mdi/js";
import reloadPasswordIcon from "../../assets/img/icon/reset_password.svg";

// js import
import { ApiKey, ApiUrl, WebUrl, AlertTypes, _MAIN_WALLET_ID } from "../../util/Constant";
import ApiEngine from "../../util/ApiEngine.js";
import { numberWithCurrencyFormat, numberWithCurrencyFormat2, stringIsNullOrEmpty, createFormBody } from "../../util/Util";
import { formatNumber } from '../../util/Util';

// redux import
import { showMessage, setBusy, setIdle, showResponseMessage, setDisplayLogin } from "../../redux/AppAction.js";
import {
  setWalletList,
  setProviderWalletData,
  setMpData,
  setShowNonSeamlessTransferConfirmation,
  enterGame,
  setShowPregamePopup
} from "../../redux/GameAction.js";
import { useHistory } from "react-router-dom";

const NonSeamlessGameWalletModal = props => {
  const { title, amount, deductedAmount, bonus, date, isOpen, transactionNumber, setIsOpen, ...rest } = props;
  const _history = useHistory();
  const { t } = useTranslation();
  const _dispatch = useDispatch();
  var timeoutRef;
  const usernameRef = useRef();
  const passwordRef = useRef();
  const _userData = useSelector((state) => state.authState.userData);
  var { isLoggedIn } = useSelector((state) => state.authState);
  const {
    productGameId,
    masterProductId,
    masterProductName,
    gameIsApp,
    gameAppUrl,
    gameAppDeepLink,
    gameAppPackageNameKeyword,
    walletList,
    providerWalletData,
    mpData,
    showPregamePopup,
    showNonSeamlessTransferConfirmation,
    playableCategory,
    masterProductCategory
  }
    = useSelector((state) => state.gameState)

  const {
    register: registerPopupTransfer,
    handleSubmit: handleSubmitPopupTransfer,
    setValue: setValuePopupTransfer,
    getValues: getValuesPopupTransfer,
    errors: errorsPopupTransfer,
    setError: setErrorPopupTransfer,
    clearErrors: clearErrorsPopupTransfer,
    watch: watchPopupTransfer
  } = useForm();

  const [amountValue, setAmountValue] = useState("0");
  const [paidAmount, setPaidAmount] = useState();
  const [transferDate, setTransferDate] = useState();
  const [isTransferSuccess, setIsTransferSuccess] = useState(false);
  const [transcactionNumber, setTranscactionNumber] = useState();
  const [currentInput, setCurrentInput] = useState();
  const [showCopyAlert, setShowCopyAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [masterProductContent, setMasterProductContent] = useState("");
  const [conversionRate, setConversionRate] = useState(0);

  useEffect(() => {

  }, []);

  const proceedNonSeamlessTransfer = async () => {
    _dispatch(setBusy());
    var responseJson = await ApiEngine.get(
      ApiUrl._API_GET_NON_SEAMLESS_PRODUCT_BALANCE +
      "?masterProductId=" +
      masterProductId
    );
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let walletData = responseJson[ApiKey._API_DATA_KEY];
      _dispatch(setWalletList(walletData));

      walletData.map((product) => {
          if (product.masterProductContent !== null) {
            setMasterProductContent(product.masterProductContent);
          } else {
            setMasterProductContent("");
          }
        })
      

      let tempProviderWalletData = walletData.filter(x => x.productId === masterProductId)[0];
      _dispatch(setProviderWalletData(tempProviderWalletData));

      var mpJson = await ApiEngine(
        ApiUrl._API_GET_MEMBER_PRODUCT_DETAILS +
        "?masterProductId=" +
        masterProductId
      );
      if (mpJson[ApiKey._API_SUCCESS_KEY]) {
        let data = mpJson[ApiKey._API_DATA_KEY];
        _dispatch(setMpData(data));

        let productName = masterProductName.replaceAll(' ', '');

        if (data.hasOwnProperty('conversionRate')) {
          data['conversionRate'].map((item) => {
            if (item.key.includes(productName + "ConversionRate")) {
              setConversionRate(item.value);
            }
          })
        }
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              action: "deeplink",
              url: gameAppUrl,
              deeplink: gameAppDeepLink
                .replace("[username]", data["username"])
                .replace("[password]", data["password"]),
              packageKeyword: gameAppPackageNameKeyword,
            })
          );
        }
      }
    }
      _dispatch(setShowPregamePopup(true));
    _dispatch(setIdle());
  }

  // Copy text
  function copyText(textType) {
    setShowCopyAlert(false);
    clearTimeout(timeoutRef);
    if (textType === "username") {
      usernameRef.current.select();
    } else if (textType === "password") {
      passwordRef.current.select();
    }
    document.execCommand("copy");
    setAlertMessage(t(textType.toUpperCase()) + " " + t("COPY_SUCCESS"));
    setShowCopyAlert(true);
    timeoutRef = setTimeout(() => setShowCopyAlert(false), 3000);
  }

  // Reset password
  async function resetProductPassword() {
    let apiUrl =
      ApiUrl._API_CHANGE_PRODUCT_PASSWORD +
      "?masterProductId=" +
      providerWalletData.productId;
    let responseJson = await ApiEngine.get(apiUrl);
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let data = responseJson[ApiKey._API_DATA_KEY];
      let tempProviderWalletData = providerWalletData;
      tempProviderWalletData.password = data.password;
      setProviderWalletData({ ...tempProviderWalletData });
    }
  }

  // Submit transfer
  const submitTransferForm = async (data, e) => {

    _dispatch(setBusy());
    let params = {
      fromWallet: _MAIN_WALLET_ID,
      toWallet: providerWalletData.productId,
      amount: parseFloat(data.amount),
    };

    let responseJson = await ApiEngine.post(
      ApiUrl._API_CREATE_WALLET_TRANSFER_TRANSACTION,
      createFormBody(params)
    );

    let responseMsg = responseJson[ApiKey._API_MESSAGE_KEY];
    responseMsg = responseMsg.replace("Amount", t("AMOUNT"));
    responseMsg = responseMsg.replace("From", t("FROM"));
    responseMsg = responseMsg.replace("Wallet", t("MAIN_WALLET"));
    responseMsg = responseMsg.replace("to", t("TO"));
    if (responseMsg.includes("Success")) {
      responseMsg = responseMsg.replace("Success", t("SUCCESS"));
    }
    else {
      responseMsg = responseMsg.replace("Failed", t("FAILED"));
      if (responseMsg.includes("Transaction")) {
        responseMsg = responseMsg.replace("Transaction", t("TRANSACTION"));
      }
    }
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      await updateWalletBalance(
        parseFloat(responseJson[ApiKey._API_DATA_KEY].amount).toFixed(2),
        providerWalletData.productId
      );
      setPaidAmount(responseJson[ApiKey._API_DATA_KEY].amount);
      setTransferDate(moment().format("YYYY-MM-DD HH:mm:ss"));
      setIsTransferSuccess(true);
      setTranscactionNumber(responseJson[ApiKey._API_DATA_KEY].transactionId);
      setAmountValue("0");
      e.target.reset();

      _dispatch(
        showResponseMessage(
          responseJson[ApiKey._API_SUCCESS_KEY],
          responseJson[ApiKey._API_MESSAGE_KEY]
        ));
    } else {
      _dispatch(
        showResponseMessage(
          responseJson[ApiKey._API_SUCCESS_KEY],
          responseMsg
        )
      );
    }
    _dispatch(setIdle());
  }

  //update wallet balance
  async function updateWalletBalance() {
    var responseJson = await ApiEngine.get(
      ApiUrl._API_GET_NON_SEAMLESS_PRODUCT_BALANCE + "?masterProductId=" +
      providerWalletData.productId
    );
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let walletData = responseJson[ApiKey._API_DATA_KEY];
      _dispatch(setWalletList(walletData));
      let tempProviderWalletData = walletData.filter(x => x.productId === providerWalletData.productId)[0];
      _dispatch(setProviderWalletData(tempProviderWalletData));
    }
  }

  const checkValueOnKeyDown = async (parsedAmtValue) => {
    clearErrorsPopupTransfer();
    let tempAmountValue = parsedAmtValue;
    setAmountValue(tempAmountValue);
    setValuePopupTransfer("amount", tempAmountValue);
    let min = 0;
    if (parseFloat(tempAmountValue) <= min) {
      setErrorPopupTransfer("amount", {
        message: t('PLEASE_ENTER_VALUE_MORE_THAN_ZERO'),
      });
    }
  }

  const onEnterGame = async (productGameId) => {
    if (isLoggedIn) {
      if (_userData.isSpecialRollover) {
        let productCategoryListArr = [...playableCategory];
        if (productCategoryListArr.includes(masterProductCategory)) {
          _dispatch(enterGame(productGameId));
        } else {
          _dispatch(showMessage({
            type: 'INFO',
            content: t('ROLLOVER_EXIST'),
            onConfirm: () => { },
          }));
        }
      } else {
        _dispatch(enterGame(productGameId));
      }
    } else {
      _dispatch(
        showMessage({
          type: AlertTypes._INFO,
          content: t("PLEASE_LOGIN_FIRST"),
          onConfirm: () => {
            //console.log("hi");
          },
        })
      );
    }
  }

  return (
    <>
      <Modal
        fade={true}
        contentClassName="modal-brand modal-bottom modal-edit-sh"
        id="confirm-non-seamless-transfer-modal"
        isOpen={showNonSeamlessTransferConfirmation}
        centered
        toggle={() => {
          _dispatch(setShowNonSeamlessTransferConfirmation(false));
        }}
      >
        <ModalBody>

          <div className="question">{t("CONFIRM_TRANSFER_NON_SEAMLESS_CREDIT", { value: masterProductName })}</div>
          <div className="buttons">
            <button className="btn btn-block btn-brand-gradient mt-3" style={{ width: "200px" }}
              onClick={() => {
                onEnterGame(productGameId);
                _dispatch(setShowNonSeamlessTransferConfirmation(false));
              }} >{t("NO") + "(" + t("START_GAME") + ")"}</button>
            <button className="btn btn-block btn-brand-gradient mt-3" style={{ width: "200px" }}
              onClick={() => {
                _dispatch(setShowNonSeamlessTransferConfirmation(false));
                proceedNonSeamlessTransfer();
              }} >{t("CONFIRM")}</button>
          </div>
        </ModalBody>
      </Modal>
      {showPregamePopup ?
        <Modal
          id="pregame-popup"
          fade={false}
          contentClassName="pregame-popup"
          isOpen={showPregamePopup}
          toggle={() => {
            _dispatch(setShowPregamePopup(false));
          }}
          centered
        >
          <ModalHeader className="m-auto border-0">
            <div className="modal-header-wrapper">
              <span className="font-20 text-white font-bold">
                {masterProductName}
              </span>
            </div>
          </ModalHeader>
          <ModalBody style={{ padding: "0px 16px 41px" }}>
            <form onSubmit={handleSubmitPopupTransfer(submitTransferForm)}>
              <div className="container">
                <div className="row">
                  <div className="col-12 d-flex wallet-info text-center text-white font-bold">
                    <div className="col-6 border-right">
                      <span className="font-15">{t("MAIN_WALLET")}</span>
                      <br />
                      {!stringIsNullOrEmpty(walletList) && walletList.length > 0 && <span className="font-16">{numberWithCurrencyFormat2((isNaN(parseFloat(walletList.filter(x => x.productId === 0)[0].balance)) ? 0 : parseFloat(walletList.filter(x => x.productId === 0)[0].balance)), 2, true)}</span>}
                    </div>
                    <div className="col-6">
                      <span className="font-15">{masterProductName}</span>
                      <br />
                      <span className="font-16">{numberWithCurrencyFormat2((isNaN(parseFloat(providerWalletData.balance)) ? 0 : parseFloat(providerWalletData.balance)), 2, true)}</span>
                    </div>
                  </div>

                  <div className="col-12 d-flex">
                    <div className="col-8">
                      <div className="pregame-transfer-input">
                        <input
                          type="text"
                          className="custom-input-style-2"
                          placeholder={"0.00"}
                          name="amount"
                          onClick={(e) => {
                            setCurrentInput(e.target);
                            checkValueOnKeyDown(e.target.value)
                          }}
                          ref={registerPopupTransfer({
                            required: "PLEASE_ENTER_AMOUNT",
                            validate: {
                              minValue: (value) =>
                                parseFloat(value) > 0 ||
                                "PLEASE_ENTER_VALUE_MORE_THAN_ZERO",
                            },
                          })}
                        />
                        {errorsPopupTransfer.amount && (
                          <div className="invalid-feedback">
                            {t(errorsPopupTransfer.amount.message)}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-4 pregame-transfer-btn">
                      <button type="submit" className="btn btn-brand-gradient">
                        {t("TRANSFER")}
                      </button>
                    </div>
                  </div>

                  <div className="col-12 d-flex transfer-balance font-15 text-white font-bold">
                    <div>{masterProductName + " " + t("NEW_BALANCE") + " : "}
                      {masterProductName == '918Kiss' || masterProductName == "D2 Poker" || masterProductName == "Pussy888" || masterProductName == "Mega888" ?
                        <div className="reminder font-11 text-white font-semi-italic">
                          1 THB = { conversionRate } point
                        </div>
                        : ""
                      }
                    </div>

                    <div>
                      {
                        masterProductName == '918Kiss' || masterProductName == "D2 Poker" || masterProductName == "Pussy888" || masterProductName == "Mega888"
                          ?
                          watchPopupTransfer("amount") > 0 &&
                          numberWithCurrencyFormat(
                            parseFloat(providerWalletData.balance) +
                            parseFloat(watchPopupTransfer("amount")) * conversionRate,
                            2,
                            true
                          )
                          :
                          watchPopupTransfer("amount") > 0 &&
                          numberWithCurrencyFormat(
                            parseFloat(providerWalletData.balance) +
                            parseFloat(watchPopupTransfer("amount")),
                            2,
                            true
                          )
                      }
                      {" "}
                      {watchPopupTransfer("amount") == "" && "-"}
                    </div>
                  </div>
                </div>
                {masterProductContent.length > 1 && !stringIsNullOrEmpty(masterProductContent) && masterProductContent !== 'undefined' && (
                  <div className="masterProductContent text-white">{masterProductContent}</div>
                )}
              </div>
            </form>
            <div className="container">
              <div className="row">
                {(providerWalletData.bonus > 0 || providerWalletData.commission > 0 || providerWalletData.clubFee > 0) && (
                  <div className="col-12 d-flex bonus-commission font-12 text-white">
                    {bonus > 0 && (
                      <div className="bonus">
                        {t("BONUS") +
                          " (%) : " +
                          numberWithCurrencyFormat(providerWalletData.bonus, 2, true) +
                          "%"}
                        &nbsp;&nbsp;
                      </div>
                    )}

                    {providerWalletData.bonus > 0 && providerWalletData.commission > 0 && <div>{"/"}&nbsp;&nbsp;</div>}

                    {providerWalletData.commission > 0 && (
                      <div className="commission">
                        {t("COMMISSION") +
                          " (%) : " +
                          numberWithCurrencyFormat(
                            providerWalletData.commission,
                            2,
                            true
                          ) +
                          "%"
                        }
                        &nbsp;&nbsp;
                      </div>
                    )}

                    {providerWalletData.commission > 0 && providerWalletData.clubFee > 0 && (
                      <div>{"/"}&nbsp;&nbsp;</div>
                    )}

                    {providerWalletData.clubFee > 0 && (
                      <div className="clubFee">
                        {t("CLUB_FEE") +
                          " (%) : " +
                          numberWithCurrencyFormat(providerWalletData.clubFee, 2, true) +
                          "%"}
                      </div>
                    )}
                  </div>
                )}
                {!gameIsApp || (gameIsApp && gameAppDeepLink !== "") && (!stringIsNullOrEmpty(mpData["username"]) && !stringIsNullOrEmpty(mpData["password"])) && (
                  <>
                    <div className="col-12" style={{ paddingBottom: "20px" }}>
                      <hr
                        style={{
                          backgroundColor: "#ffc159",
                          width: "90%",
                          padding: "0.5px 0",
                        }}
                      />
                      <div
                        className="text-center"
                        style={{
                          marginTop: "-28px",
                        }}
                      >
                        <span
                          className="font-16 text-gold font-bold"
                          style={{
                            backgroundColor: "#001A3D",
                            padding: "0 25px",
                          }}
                        >
                          {masterProductName + " " + t("ACCOUNT")}
                        </span>
                      </div>
                    </div>
                    <div className="username-and-password">
                      <div className="details username">
                        <div className="details-label">
                          {t("USERNAME") + " : "}
                        </div>
                        <input
                          type="text"
                          className="username-input"
                          value={mpData["username"]}
                          ref={usernameRef}
                          readOnly
                        />
                        <div
                          style={{ marginLeft: "10px" }}
                          onClick={() => copyText("username")}
                        >
                          <Icon path={mdiContentCopy} size={1} color="#ffc159" />
                        </div>
                      </div>
                      <div className="details password">
                        <div className="details-label">
                          {t("PASSWORD") + " : "}
                        </div>
                        <input
                          type="text"
                          className="password-input"
                          value={mpData["password"]}
                          ref={passwordRef}
                          readOnly
                        />
                        <div
                          style={{ marginLeft: "10px" }}
                          onClick={() => copyText("password")}
                        >
                          <Icon path={mdiContentCopy} size={1} color="#ffc159" />
                        </div>
                        <div
                          className="refresh-password-btn"
                          style={{
                            backgroundImage: `url(${reloadPasswordIcon})`,
                          }}
                          onClick={() => resetProductPassword(masterProductId)}
                        >
                          <div className="tooltip-text">
                            <span>{t("REFRESH_PASSWORD")}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {masterProductName == "Mega888" && (
                  <>
                    <div className="col-12" style={{ paddingBottom: "20px" }}>
                      <hr
                        style={{
                          backgroundColor: "#ffc159",
                          width: "90%",
                          padding: "0.5px 0",
                        }}
                      />
                      <div
                        className="text-center"
                        style={{
                          marginTop: "-28px",
                        }}
                      >
                        <span
                          className="font-16 text-gold font-bold"
                          style={{
                            backgroundColor: "#001A3D",
                            padding: "0 25px",
                          }}
                        >
                          {masterProductName + " " + t("ACCOUNT")}
                        </span>
                      </div>
                    </div>
                    <div className="username-and-password">
                      <div className="details username">
                        <div className="details-label">
                          {t("USERNAME") + " : "}
                        </div>
                        <input
                          type="text"
                          className="username-input"
                          value={mpData["username"]}
                          ref={usernameRef}
                          readOnly
                        />
                        <div
                          style={{ marginLeft: "10px" }}
                          onClick={() => copyText("username")}
                        >
                          <Icon path={mdiContentCopy} size={1} color="#ffc159" />
                        </div>
                      </div>
                      <div className="details password">
                        <div className="details-label">
                          {t("PASSWORD") + " : "}
                        </div>
                        <input
                          type="text"
                          className="password-input"
                          value={mpData["password"]}
                          ref={passwordRef}
                          readOnly
                        />
                        <div
                          style={{ marginLeft: "10px" }}
                          onClick={() => copyText("password")}
                        >
                          <Icon path={mdiContentCopy} size={1} color="#ffc159" />
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <div className="col-12 d-flex start-btn-wrapper">
                {(gameAppDeepLink != "") ? (
                  <button
                    type="button"
                      onClick={() => {
                        onEnterGame(productGameId);
                    }}
                    className="btn pregame-popup-btn btn-block btn-brand"
                  >
                    {t("START_GAME")}
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={() => {
                      if (window.ReactNativeWebView) {
                        window.ReactNativeWebView.postMessage(
                          JSON.stringify({ url: gameAppUrl })
                        );
                      } else {
                        window.open(gameAppUrl);
                      }
                    }}
                    className="btn pregame-popup-btn btn-block btn-brand"
                  >
                    {t("DOWNLOAD_APP")}
                  </button>
                )}
                </div>
              </div>
            </div>
            <div
              className="pregame-popup-close-btn"
              onClick={() => {
                _dispatch(setShowPregamePopup(false));
              }}
            >
              <img
                src="/img/assets/close.svg"
                className="img-responsive"
                alt="close"
              />
            </div>
          </ModalBody>
        </Modal>
        :
        <></>
      }

    </>
  );
};

export default NonSeamlessGameWalletModal;